<template>
    <a :href="linkUrl||'javascript:;'" class="fans_item">
        <img :src="imgSrcLink" alt="">
        <div class="fans_name">{{userName}}</div>
    </a>
</template>
<script>
export default {
    name: 'fansitem',
    props:['imgSrc','name','jumpLink'],
    data(){
        return {
            imgSrcLink:this.imgSrc,
            userName:this.name,
            linkUrl:this.jumpLink
        }
    }
}
</script>
<style lang="stylus">
    .fans_item
        display:block
        height:3.5rem
        padding:0 0.75rem 0 1rem
        line-height:3.5rem
        position:relative
        img
            width:2.5rem
            height:2.5rem
            border-radius:50%
            position:absolute
            top:50%
            margin-top:-1.25rem
            vertical-align:top
        .fans_name
            height:3.5rem
            margin-left:2.5rem
            font-size:.7rem
            color:#505050
            border-bottom:1px solid #ebebeb
            padding-left:0.5rem
</style>



// WEBPACK FOOTER //
// fansitem.vue?1abf0a41